/**
 * Gravity Forms Consent Review Module
 */

import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        this.setupConsentReviewConfig();
        this.bindConsentReviewEvents();
        this.updateAllConsentReviews();
    },

    setupConsentReviewConfig() {
        this.consentReviewConfig = {
            formSelector: 'form[id^="gform_"]',
            clientReviewClass: 'consent-review--client',
            counterReviewClass: 'consent-review--counter',
            inputTimeout: null
        };

        this.consentFieldMap = {
            // Service
            service: { id: 1, label: 'Service', cssClass: 'consent-field--service' },

            // Tattoo
            tattooArtist: { id: 10, label: 'Tattoo Artist', cssClass: 'consent-field--tattooArtist' },
            tattooDescription: { id: 12, label: 'Tattoo Description', cssClass: 'consent-field--tattooDescription' },
            tattooBodyLocation: { id: 13, label: 'Tattoo Body Location', cssClass: 'consent-field--tattooBodyLocation' },
            tattooCost: { id: 14, label: 'Tattoo Cost', cssClass: 'consent-field--tattooCost' },
            tattooHourly: { id: null, label: 'Hourly Rate', cssClass: 'consent-field--hourly' },

            // Piercing
            piercer: { id: 3, label: 'Piercer', cssClass: 'consent-field--piercer' },
            piercing: { id: 4, label: 'Piercing', cssClass: 'consent-field--piercing' },
            piercingCost: { id: 5, label: 'Piercing Cost', cssClass: 'consent-field--piercingCost' },
            jewelry: { id: 7, label: 'Jewelry', cssClass: 'consent-field--jewelry' },
            jewelryCost: { id: 8, label: 'Jewelry Cost', cssClass: 'consent-field--jewelryCost' },
            deposit: { id: 9, label: 'Deposit', cssClass: 'consent-field--deposit' },

            // Client - UPDATED IDS
            nameLegal: { id: 79, label: 'Legal Name', cssClass: 'consent-field--nameLegal' },
            nameChosen: { id: 18, label: 'Chosen Name', cssClass: 'consent-field--nameChosen' },
            birthdate: { id: 80, label: 'Birthdate', cssClass: 'consent-field--birthdate' },
            mailingAddress: { id: 20, label: 'Mailing Address', cssClass: 'consent-field--mailingAddress' },
            phoneNumber: { id: 21, label: 'Phone Number', cssClass: 'consent-field--phoneNumber' },
            emailAddress: { id: 22, label: 'Email Address', cssClass: 'consent-field--emailAddress' },

            // Guardian
            guardianName: { id: 23, label: 'Guardian\'s Legal Name', cssClass: 'consent-field--guardianName' },
            guardianRelationship: { id: 24, label: 'Relationship to Minor', cssClass: 'consent-field--guardianRelationship' },

            // Questions
            previousClient: { id: 29, label: 'Previous Client?', cssClass: 'consent-field--previousClient' },
            referrer: { id: 30, label: 'What brought you to Imperial?', cssClass: 'consent-field--referrer' },
            hasEaten: { id: 31, label: 'Eaten Recently?', cssClass: 'consent-field--hasEaten' },
            bloodborne: { id: 32, label: 'Bloodborne Pathogens?', cssClass: 'consent-field--bloodborne' },
            allergies: { id: 33, label: 'Known Allergies', cssClass: 'consent-field--allergies' },
            photography: { id: 34, label: 'Photography?', cssClass: 'consent-field--photography' },

            // ID
            idNumber: { id: 41, label: 'Your ID Number', cssClass: 'consent-field--idNumber' },

            // Signature
            signatureTyped: { id: 69, label: 'Your Signature Typed', cssClass: 'consent-form--signTyped' },

            // Consent fields
            generalRelease: { id: 49, label: 'General Release', cssClass: 'consent-field--agreeGeneral', dateFieldId: 50 },
            generalReleaseDate: { id: 50, label: 'General Release Date', cssClass: '', inputName: 'consent-data--agreeGeneralDate' },
            medicalRelease: { id: 61, label: 'Medical Release', cssClass: 'consent-field--agreeMedical', dateFieldId: 62 },
            medicalReleaseDate: { id: 62, label: 'Medical Release Date', cssClass: '', inputName: 'consent-data--agreeMedicalDate' },
            aftercareConfirmation: { id: 67, label: 'Aftercare Confirmation', cssClass: 'consent-field--agreeMedical', dateFieldId: 70 },
            aftercareConfirmationDate: { id: 70, label: 'Aftercare Confirmation Date', cssClass: '', inputName: 'consent-data--agreeAftercareDate' },

            // Calculated field
            estimatedCost: { id: null, label: 'Estimated Cost (due on completion)', cssClass: 'consent-field--estimatedCost' }
        };
    },

    bindConsentReviewEvents() {
        const self = this;

        $(document).on('change', `${this.consentReviewConfig.formSelector} input, ${this.consentReviewConfig.formSelector} select, ${this.consentReviewConfig.formSelector} textarea`, function() {
            const $form = $(this).closest(self.consentReviewConfig.formSelector);
            self.updateConsentReviewSections($form);
        });

        $(document).on('input', `${this.consentReviewConfig.formSelector} input[type="text"], ${this.consentReviewConfig.formSelector} input[type="number"], ${this.consentReviewConfig.formSelector} textarea`, function() {
            const $form = $(this).closest(self.consentReviewConfig.formSelector);

            clearTimeout(self.consentReviewConfig.inputTimeout);
            self.consentReviewConfig.inputTimeout = setTimeout(() => {
                self.updateConsentReviewSections($form);
            }, 300);
        });

        // Listen for consent checkbox changes to populate date fields
        $(document).on('change', `${this.consentReviewConfig.formSelector} input[type="checkbox"]`, function() {
            const $checkbox = $(this);
            const $form = $checkbox.closest(self.consentReviewConfig.formSelector);
            const formId = self.getConsentFormId($form);

            console.log('Checkbox changed:', $checkbox.attr('id'), 'Checked:', $checkbox.is(':checked'));

            // Check if this is one of our consent checkboxes
            const consentMappings = [
                { checkboxId: 49, dateFieldId: 50, dateInputName: 'consent-data--agreeGeneralDate', label: 'General Release' },
                { checkboxId: 61, dateFieldId: 62, dateInputName: 'consent-data--agreeMedicalDate', label: 'Medical Release' },
                { checkboxId: 67, dateFieldId: 70, dateInputName: 'consent-data--agreeAftercareDate', label: 'Aftercare' }
            ];

            consentMappings.forEach(mapping => {
                // Consent checkboxes have IDs like input_2_49_1 (with _1 suffix)
                const checkboxId = $checkbox.attr('id');
                const matchesById = checkboxId === `input_${formId}_${mapping.checkboxId}_1`;
                const matchesByName = $checkbox.attr('name') === `input_${mapping.checkboxId}`;

                if (matchesById || matchesByName) {
                    console.log('✓ Matched consent field:', mapping.label, '(field', mapping.checkboxId + ')');
                    console.log('  Looking for date field with name:', mapping.dateInputName);

                    // Try multiple selectors to find the hidden field
                    let $dateField = $form.find(`input[name="${mapping.dateInputName}"]`);

                    if (!$dateField.length) {
                        console.log('  Trying by ID: #input_' + formId + '_' + mapping.dateFieldId);
                        $dateField = $form.find(`#input_${formId}_${mapping.dateFieldId}`);
                    }

                    if (!$dateField.length) {
                        console.log('  Trying by type=hidden with partial name match');
                        $dateField = $form.find(`input[type="hidden"][name*="agreeGeneralDate"], input[type="hidden"][name*="agreeMedicalDate"], input[type="hidden"][name*="agreeAftercareDate"]`).filter(function() {
                            return $(this).attr('name').includes(mapping.dateInputName.split('--')[1]);
                        });
                    }

                    console.log('  Date field found:', $dateField.length);

                    if ($dateField.length) {
                        console.log('  Date field ID:', $dateField.attr('id'), 'Name:', $dateField.attr('name'));

                        if ($checkbox.is(':checked')) {
                            // Populate with current date/time in Y-m-d H:i:s format
                            const now = new Date();
                            const year = now.getFullYear();
                            const month = String(now.getMonth() + 1).padStart(2, '0');
                            const day = String(now.getDate()).padStart(2, '0');
                            const hours = String(now.getHours()).padStart(2, '0');
                            const minutes = String(now.getMinutes()).padStart(2, '0');
                            const seconds = String(now.getSeconds()).padStart(2, '0');
                            const dateTimeStamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                            console.log('  ✓ Setting date field to:', dateTimeStamp);
                            $dateField.val(dateTimeStamp);
                            console.log('  ✓ Value now:', $dateField.val());
                        } else {
                            // Clear the date field if unchecked
                            console.log('  ✓ Clearing date field');
                            $dateField.val('');
                            console.log('  ✓ Value now:', $dateField.val());
                        }

                        // Trigger change event to update review
                        self.updateConsentReviewSections($form);
                    } else {
                        console.log('  ✗ Date field NOT found! Dumping all hidden inputs:');
                        $form.find('input[type="hidden"]').each(function() {
                            console.log('    -', $(this).attr('id'), '|', $(this).attr('name'));
                        });
                    }
                }
            });
        });

        $(document).on('gform_page_loaded', (event, formId, currentPage) => {
            const $form = $(`#gform_${formId}`);
            if ($form.length) {
                self.updateConsentReviewSections($form);
            }
        });

        $(document).ready(() => {
            self.updateAllConsentReviews();
        });
    },

    updateAllConsentReviews() {
        const self = this;
        $(this.consentReviewConfig.formSelector).each(function() {
            const $form = $(this);
            if ($form.find(`.${self.consentReviewConfig.clientReviewClass}, .${self.consentReviewConfig.counterReviewClass}`).length) {
                self.updateConsentReviewSections($form);
            }
        });
    },

    updateConsentReviewSections($form) {
        const formId = this.getConsentFormId($form);
        if (!formId) return;

        const reviewHTML = this.buildConsentReviewHTML($form, formId);
        const counterReviewHTML = this.buildCounterReviewHTML($form, formId, reviewHTML);

        const $clientReview = $form.find(`.${this.consentReviewConfig.clientReviewClass}`);
        if ($clientReview.length) {
            $clientReview.html(reviewHTML);
        }

        const $counterReview = $form.find(`.${this.consentReviewConfig.counterReviewClass}`);
        if ($counterReview.length) {
            $counterReview.html(counterReviewHTML);
        }
    },

    buildCounterReviewHTML($form, formId, baseReviewHTML) {
        // Start with the base review HTML
        let html = baseReviewHTML;

        // Add consent releases section (only for counter)
        const consentFields = [
            {
                key: 'generalReleaseDate',
                value: this.getConsentFieldValue($form, formId, this.consentFieldMap.generalReleaseDate.id),
                format: 'datetime',
                customLabel: 'General Release Signed'
            },
            {
                key: 'medicalReleaseDate',
                value: this.getConsentFieldValue($form, formId, this.consentFieldMap.medicalReleaseDate.id),
                format: 'datetime',
                customLabel: 'Medical Release Signed'
            },
            {
                key: 'aftercareConfirmationDate',
                value: this.getConsentFieldValue($form, formId, this.consentFieldMap.aftercareConfirmationDate.id),
                format: 'datetime',
                customLabel: 'Aftercare Signed'
            }
        ];

        html += this.buildSection('Release Forms', consentFields, 'consents');

        return html;
    },

    getConsentFormId($form) {
        const idMatch = $form.attr('id').match(/gform_(\d+)/);
        return idMatch ? parseInt(idMatch[1]) : null;
    },

    getConsentFieldValue($form, formId, fieldId) {
        // Radio buttons first
        const $radioChecked = $form.find(`input[name="input_${fieldId}"]:checked`);
        if ($radioChecked.length) {
            return $radioChecked.val();
        }

        // Try select dropdown (for relationship field)
        let $select = $form.find(`#input_${formId}_${fieldId}`);
        if ($select.length && $select.is('select')) {
            return $select.val() || '';
        }

        // Standard text/email/number input (but not span containers)
        let $field = $form.find(`#input_${formId}_${fieldId}`);
        if ($field.length && ($field.is('input') || $field.is('textarea'))) {
            if ($field.is(':checkbox')) {
                const $checked = $form.find(`input[name="input_${fieldId}"]:checked`);
                return $checked.length ? $checked.val() : '';
            }
            return $field.val() || '';
        }

        // Checkboxes
        const $checkboxes = $form.find(`input[name^="input_${fieldId}["]:checked`);
        if ($checkboxes.length) {
            return $checkboxes.map(function() { return $(this).val(); }).get().join(', ');
        }

        // Complex fields (name, address, etc.)
        const complexSelector = `input[id^="input_${formId}_${fieldId}_"]:not([type="hidden"]), select[id^="input_${formId}_${fieldId}_"]`;
        const $allComplex = $form.find(complexSelector);

        if ($allComplex.length) {
            const values = [];
            $allComplex.each(function() {
                const $el = $(this);
                const val = $el.val();
                if (val && val.toString().trim() !== '') {
                    values.push(val);
                }
            });
            if (values.length > 0) {
                // Check if this is an address field (field 20)
                // Address format: Street, City, State ZIP, Country
                if (fieldId === 20 && values.length >= 4) {
                    // values are typically: [street, street2, city, state, zip, country]
                    const street = values[0];
                    const street2 = values.length > 5 ? values[1] : null;
                    const city = values.length > 5 ? values[2] : values[1];
                    const state = values.length > 5 ? values[3] : values[2];
                    const zip = values.length > 5 ? values[4] : values[3];
                    const country = values.length > 5 ? values[5] : values[4];

                    let formatted = street;
                    if (street2) formatted += ' ' + street2;
                    formatted += ', ' + city + ', ' + state + ' ' + zip;
                    if (country) formatted += ', ' + country;

                    return formatted;
                }

                return values.join(' ');
            }
        }

        return '';
    },

    calculateAge(birthdate) {
        if (!birthdate) return null;

        const parts = birthdate.split('/');
        if (parts.length !== 3) return null;

        const birthMonth = parseInt(parts[0], 10);
        const birthDay = parseInt(parts[1], 10);
        const birthYear = parseInt(parts[2], 10);

        if (isNaN(birthMonth) || isNaN(birthDay) || isNaN(birthYear)) return null;

        const today = new Date();
        const birthDate = new Date(birthYear, birthMonth - 1, birthDay);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    },

    buildConsentReviewHTML($form, formId) {
        let html = '';

        // Get service type
        const service = this.getConsentFieldValue($form, formId, this.consentFieldMap.service.id);

        // Get birthdate and calculate age
        const birthdateValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.birthdate.id);
        const age = this.calculateAge(birthdateValue);
        const isAdult = age !== null && age >= 18;

        // Get name for titles
        const chosenName = this.getConsentFieldValue($form, formId, this.consentFieldMap.nameChosen.id);
        const legalNameFull = this.getConsentFieldValue($form, formId, this.consentFieldMap.nameLegal.id);
        const firstName = legalNameFull ? legalNameFull.split(' ')[0] : '';
        const displayName = chosenName || firstName;

        // Get money values for calculation
        const depositValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.deposit.id);
        const depositCents = this.parseMoney(depositValue);

        // SERVICE SECTION - "Work Getting Done"
        const serviceFields = [];
        let estimatedCostCents = 0;

        if (service) {
            serviceFields.push({ key: 'service', value: service });

            if (service === 'Tattoo') {
                const tattooCostValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.tattooCost.id);
                const tattooCostCents = this.parseMoney(tattooCostValue);

                // Check if hourly checkbox is checked
                const $hourlyCheckbox = $form.find('.consent-field--hourly input[type="checkbox"]');
                const isHourly = $hourlyCheckbox.length > 0 && $hourlyCheckbox.is(':checked');

                serviceFields.push(
                   { key: 'tattooArtist', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.tattooArtist.id) },
                   { key: 'tattooDescription', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.tattooDescription.id) },
                   { key: 'tattooBodyLocation', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.tattooBodyLocation.id) },
                   {
                       key: 'tattooCost',
                       value: tattooCostValue,
                       format: 'currency',
                       storeMoney: true,
                       customLabel: isHourly ? 'Tattoo Cost (hourly)' : undefined
                   }
                );

                // Only calculate estimated cost if NOT hourly
                if (!isHourly) {
                    estimatedCostCents = tattooCostCents - depositCents;
                }
            } else if (service === 'Piercing') {
                const piercingCostValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.piercingCost.id);
                const jewelryCostValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.jewelryCost.id);
                const piercingCostCents = this.parseMoney(piercingCostValue);
                const jewelryCostCents = this.parseMoney(jewelryCostValue);

                serviceFields.push(
                   { key: 'piercer', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.piercer.id) },
                   { key: 'piercingCost', value: piercingCostValue, format: 'currency', storeMoney: true },
                   { key: 'jewelry', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.jewelry.id) },
                   { key: 'jewelryCost', value: jewelryCostValue, format: 'currency', storeMoney: true }
                );

                estimatedCostCents = piercingCostCents + jewelryCostCents - depositCents;
            }

            serviceFields.push({ key: 'deposit', value: depositValue, format: 'currency', storeMoney: true });

            // Add estimated cost
            if (estimatedCostCents > 0) {
                const estimatedCostDisplay = `$${(estimatedCostCents / 100).toFixed(2)}`;
                serviceFields.push({
                    key: 'estimatedCost',
                    value: estimatedCostDisplay,
                    format: 'currency',
                    storeMoney: true,
                    customLabel: 'Estimated Cost (due on completion)'
                });
            }
        }
        html += this.buildSection('Work Getting Done', serviceFields, 'service');

        // CLIENT SECTION - "Person getting a [Service]" (includes questionnaire)
        const clientSectionTitle = service ? `Person getting a ${service}` : 'Client Information';
        const clientFields = [
            { key: 'nameLegal', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.nameLegal.id) },
            { key: 'nameChosen', value: chosenName },
            { key: 'birthdate', value: birthdateValue, formatAge: true, age: age },
            { key: 'mailingAddress', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.mailingAddress.id) },
            { key: 'phoneNumber', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.phoneNumber.id), format: 'phone' },
            { key: 'emailAddress', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.emailAddress.id) },
            // Questionnaire fields merged in
            { key: 'previousClient', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.previousClient.id) },
            { key: 'referrer', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.referrer.id) },
            { key: 'hasEaten', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.hasEaten.id) },
            { key: 'bloodborne', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.bloodborne.id) },
            { key: 'allergies', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.allergies.id) },
            { key: 'photography', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.photography.id) }
        ];
        html += this.buildSection(clientSectionTitle, clientFields, 'client');

        // GUARDIAN SECTION - "Guardian of [Name]" - ONLY if under 18
        if (!isAdult) {
            const guardianSectionTitle = displayName ? `Guardian of ${displayName}` : 'Guardian Information';
            const guardianFields = [
                { key: 'guardianName', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.guardianName.id) },
                { key: 'guardianRelationship', value: this.getConsentFieldValue($form, formId, this.consentFieldMap.guardianRelationship.id) }
            ];
            html += this.buildSection(guardianSectionTitle, guardianFields, 'guardian');
        }

        // IDENTIFICATION SECTION
        const idNumberValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.idNumber.id);
        const signatureTypedValue = this.getConsentFieldValue($form, formId, this.consentFieldMap.signatureTyped.id);
        const idFields = [
            { key: 'idNumber', value: idNumberValue, obscure: true },
            { key: 'signatureTyped', value: signatureTypedValue }
        ];
        html += this.buildSection('Identification', idFields, 'identification');

        return html;
    },

    parseMoney(value) {
        if (!value) return 0;
        const numValue = parseFloat(value.toString().replace(/[^0-9.]/g, ''));
        return isNaN(numValue) ? 0 : Math.round(numValue * 100);
    },

    formatBirthdate(value, age) {
        if (!value) return value;

        // Parse MM/DD/YYYY
        const parts = value.split('/');
        if (parts.length !== 3) return value;

        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];

        const formattedDate = `${monthNames[month - 1]} ${day}, ${year}`;

        if (age !== null && age !== undefined) {
            return `${formattedDate} (age ${age})`;
        }

        return formattedDate;
    },

    obscureIdNumber(value) {
        if (!value || value.length <= 4) return value;

        const last4 = value.slice(-4);
        const obscured = '*'.repeat(value.length - 4);
        return obscured + last4;
    },

    buildSection(title, fields, sectionKey) {
        // Filter out empty fields
        const validFields = fields.filter(f => f.value && f.value.toString().trim() !== '');

        if (validFields.length === 0) {
            return '';
        }

        const sectionClass = sectionKey ? ` review-section--${sectionKey}` : '';
        let html = `<div class="review-section${sectionClass}"><h3 class="review-section__title">${title}</h3><ul class="review-list">`;

        validFields.forEach(field => {
            const fieldConfig = this.consentFieldMap[field.key];
            let displayValue = field.value;

            // Handle special formatting
            if (field.formatAge && field.age !== null && field.age !== undefined) {
                displayValue = this.formatBirthdate(field.value, field.age);
            } else if (field.obscure) {
                displayValue = this.obscureIdNumber(field.value);
            } else {
                displayValue = this.formatConsentValue(field.value, field.format);
            }

            let storedValue = field.value;
            if (field.storeMoney && field.value) {
                const numValue = parseFloat(field.value.toString().replace(/[^0-9.]/g, ''));
                if (!isNaN(numValue)) {
                    storedValue = Math.round(numValue * 100);
                }
            }

            const dataAttr = field.storeMoney && storedValue !== field.value ? ` data-stored-value="${storedValue}"` : '';

            // Use custom label if provided, otherwise use config label
            const label = field.customLabel || fieldConfig.label;

            html += `<li class="review-item review-item--${field.key}"${dataAttr}>`;
            html += `<span class="review-item__label">${label}: </span>`;
            html += `<span class="review-item__value">${this.escapeConsentHtml(displayValue)}</span>`;
            html += `</li>`;
        });

        html += `</ul></div>`;

        return html;
    },

    formatConsentValue(value, format) {
        if (!value) return value;

        switch (format) {
            case 'currency':
                const numValue = parseFloat(value.toString().replace(/[^0-9.]/g, ''));
                return isNaN(numValue) ? value : `$${numValue.toFixed(2)}`;

            case 'phone':
                const cleaned = value.replace(/\D/g, '');
                if (cleaned.length === 10) {
                    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
                }
                return value;

            case 'datetime':
                return this.formatDateTime(value);

            default:
                return value;
        }
    },

    formatDateTime(value) {
        if (!value) return value;

        // Parse Y-m-d H:i:s format (e.g., "2025-11-06 16:32:45")
        const parts = value.split(' ');
        if (parts.length !== 2) return value;

        const dateParts = parts[0].split('-');
        const timeParts = parts[1].split(':');

        if (dateParts.length !== 3 || timeParts.length !== 3) return value;

        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1; // JS months are 0-indexed
        const day = parseInt(dateParts[2]);
        const hour = parseInt(timeParts[0]);
        const minute = parseInt(timeParts[1]);
        const second = parseInt(timeParts[2]);

        const date = new Date(year, month, day, hour, minute, second);

        // Format as "Thursday, November 6, 2025 • 4:16pm"
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];

        const dayName = dayNames[date.getDay()];
        const monthName = monthNames[date.getMonth()];
        const dayNum = date.getDate();
        const yearNum = date.getFullYear();

        // Format time as 12-hour with am/pm
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // 0 should be 12

        return `${dayName}, ${monthName} ${dayNum}, ${yearNum} • ${hours}:${minutes}${ampm}`;
    },

    escapeConsentHtml(text) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.toString().replace(/[&<>"']/g, m => map[m]);
    }
};